import { setLocation } from 'utils/wrappers';
import Session from 'app/models/session';

import Base from 'app/views/base';
import tmpl from 'templates/user_nav';

const { EasyPost } = global;

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #signout': 'signOut',
  },

  initialize() {
    this.listenTo(this.model, 'sync', this.render);
  },

  context() {
    return {
      loggedIn: this.model.isLoggedIn(),
      email: this.model.get('email'),
      collection: this.collection,
    };
  },

  setPageAndRender(pageName) {
    this.currentPage = pageName;
    this.render();
  },

  signOut(e) {
    e.preventDefault();
    new Session({ id: 'deleteme' }).destroy({
      success() {
        setLocation('/');
      },
      error() {
        EasyPost.Globals.currentUser.fetch({
          error() {
            setLocation('/');
          },
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/user_nav_view.js